module.exports = __webpack_public_path__ + "static/media/vn.56dc8bf0.svg";